import supabase from '../supabase/supabase';

export async function removeDeliveryDistrict(rateId) {
  const {error} = await supabase.rpc(
    'zevi_admin_remove_shipping_district_20260925',
    {input_rate_id: rateId}
  );

  if (error) {
    throw new Error(
      error.code === 'PGRST202'
        ? 'Apply the district-removal database migration before removing districts.'
        : error.message || 'The delivery district could not be removed.'
    );
  }
}